import { GridProvider } from '../../molecules';

//hook used internally to update Grid Store
const useDataGrid = () => GridProvider.useStore();

//hook that can be used externally by downstream devs
const useGrid = () => {
    const {
        updateCachedTableData,
        cachedTableData: tableData,
        isLoading,
        totalDataCount,
        onRefresh: refetchData
    } = useDataGrid();


    return {
        updateCachedTableData,
        tableData,
        isLoading,
        totalDataCount,
        refetchData
    }
}

export { useGrid };
export default useDataGrid;